import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

export default function Header({ showBack = false }) {
  return (
    <header className="site-header">
      <div className="container header-inner">
        <Link to="/" className="header-logo">
          <span className="header-logo-icon">B</span>
          {process.env.REACT_APP_BRAND_NAME || 'Bystrov'}
        </Link>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {showBack && (
            <Link to="/" className="header-back">← Назад</Link>
          )}
          <Link to="/chat" className="header-chat-btn">
            💬 Написать
          </Link>
        </div>
      </div>
    </header>
  );
}